<template>
    <b-card class="mb-5">
        <b-row>
            <b-col md="6">
                <h3>{{$route.name}}</h3>
                <b-breadcrumb>
                <b-breadcrumb-item><router-link to="/dashboard">{{$t('dashboard')}}</router-link></b-breadcrumb-item>
                <b-breadcrumb-item><router-link to="/overtime">{{$t('overtime')}}</router-link></b-breadcrumb-item>
                <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
                </b-breadcrumb>
            </b-col>
            <b-col md="6" class="text-right mt-3" v-if="model.status === 'Requested'">
                <b-button variant="danger" class="btn-sm mr-2" @click="showModal('reject')">
                    <font-awesome-icon icon="times-circle"></font-awesome-icon> {{$t('rej')}}
                </b-button>
                <b-button variant="success" class="btn-sm" @click="showModal('approve')">
                    <font-awesome-icon icon="check-circle"></font-awesome-icon> {{$t('appr')}}
                </b-button>
            </b-col>
        </b-row>
        <div class="border-bottom mb-3"/>
        <template v-if="isLoading">
            <div class="d-flex justify-content-center mb-5 mt-5 pt-5 pb-5">
                <b-spinner style="width: 3rem; height: 3rem;" variant="primary" label="Loading..."></b-spinner>
            </div>
        </template>
        <template v-else>
            <b-form class="mt-4 mx-2">
                <b-row>
                    <b-col md="5">
                        <b-row>
                            <b-col md="4">
                                <label class="labels">{{('requestedBy')}}</label>
                            </b-col>
                            <b-col md="8">
                                <p>{{ model.requestedBy !== null ? model.requestedBy : '-' }}</p>
                            </b-col>
                        </b-row>
                        <b-row v-if="model.statusValue !== ''">
                            <b-col md="4">
                                <label class="labels">{{model.statusText}}</label>
                            </b-col>
                            <b-col md="8">
                                <p>{{ model.statusValue }}</p>
                            </b-col>
                        </b-row>
                        <b-row v-if="model.statusTime !== ''">
                            <b-col md="4">
                                <label class="labels">{{model.statusTextTime}}</label>
                            </b-col>
                            <b-col md="8">
                                <p>{{ model.statusTime }}</p>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4">
                                <label class="labels">{{('totalHours')}}</label>
                            </b-col>
                            <b-col md="8">
                                <p>{{ model.hour }}</p>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4">
                                <label class="labels">{{('START')}}</label>
                            </b-col>
                            <b-col md="8">
                                <p>{{ model.startTime !== null ? getDateTime(model.startTime) : '-' }}</p>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4">
                                <label class="labels">{{$t('END')}}</label>
                            </b-col>
                            <b-col md="8">
                                <p>{{ model.endTime !== null ? getDateTime(model.endTime) : '-' }}</p>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4">
                                <label class="labels">{{$t('type')}}</label>
                            </b-col>
                            <b-col md="8">
                                <p>{{ model.overtimeType }}</p>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4">
                                <label class="labels">{{$t('note')}}</label>
                            </b-col>
                            <b-col md="8">
                                <p>{{ model.note !== null ? model.note : '-' }}</p>
                            </b-col>
                        </b-row>
                        <!-- <b-row>
                            <b-col md="4">
                                <label class="labels">End</label>
                            </b-col>
                            <b-col md="8">
                                <p>{{ model.endTime !== null ? getDateTime(model.endTime) : '-' }}</p>
                            </b-col>
                        </b-row> -->
                        <b-row>
                            <b-col md="4">
                                <label class="labels">Status</label>
                            </b-col>
                            <b-col md="8">
                                <p><b-badge :variant="getStatusColor(model.status)">{{model.status}}</b-badge></p>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4">
                                <label class="labels">{{$t('CREATED')}}</label>
                            </b-col>
                            <b-col md="8">
                                <p>{{ model.createdAt !== null ? getDateTime(model.createdAt) : '-' }}</p>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col md="7">
                        <GmapMap
                            :center="model.position"
                            :zoom="17"
                            map-type-id="terrain"
                            style="width: 100%; height: 100%"
                        >
                            <GmapMarker
                                :position="model.position"
                                :clickable="true"
                                :draggable="true"
                                @click="center=model.position"
                            />
                        </GmapMap>
                    </b-col>
                </b-row>
                <b-row class="mt-3 mb-4">
                    <b-col>
                        <h5 class="pb-3">{{$t('photo')}}</h5>
                    </b-col>
                    <b-col md="12">
                        <b-row v-if="model.overtimePhotoList.length === 0">
                            <b-col md="3">
                                <p class="text-secondary text-center border p-5"><i>No Photo Submitted</i></p>
                            </b-col>
                        </b-row>
                        <viewer :images="model.overtimePhotoList" v-else>
                            <b-row>
                                <b-col md="3" v-for="(src, index) in model.overtimePhotoList" :key="index">
                                    <p class="text-secondary text-center border p-5" v-if="src === null"><i>No Photo Submitted</i></p>
                                    <b-img v-else :src="src" class="img-responsive" width="300" height="200"/>
                                </b-col>
                            </b-row>
                        </viewer>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <h5 class="mb-3">Overtime Status History</h5>
                    </b-col>
                    <b-col md="12">
                        <div class="table-responsive">
                        <table class="table table-hovered table-striped">
                            <thead>
                                <tr>
                                    <th scope="col" width="100">Status</th>
                                    <th scope="col" width="250">{{$t('changedBy')}}</th>
                                    <th scope="col">{{('note')}}</th>
                                    <th scope="col" width="200">{{('time')}}</th>
                                </tr>
                            </thead>
                            <tbody v-if="overtimeHistoryStatusList.length > 0">
                            <tr v-for="report in overtimeHistoryStatusList" :key="report.uuid">
                                <td><b-badge :variant="getStatusColor(report.status)">{{report.status}}</b-badge></td>
                                <td>{{report.changedBy}}</td>
                                <td>{{report.note !== null ? report.note : '-'}}</td>
                                <td>{{report.createdAt !== null ? getDateTime(report.createdAt) : '-'}}</td>
                            </tr>
                            </tbody>
                            <tbody v-else>
                            <tr>
                                <td colspan="9" class="text-center">there's no data</td>
                            </tr>
                            </tbody>
                        </table>
                        </div>
                    </b-col>
                </b-row>
            </b-form>
            <b-button class="mt-3" @click="goBack" variant="secondary"><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button>
        </template>
        <b-modal id="bv-modal-example" hide-footer>
            <template v-slot:modal-title>
                <h5 class="text-transform">{{type}} {{$t('overtime')}}</h5>
            </template>
            <form v-on:submit.prevent="doChangeStatus(type)">
                <div class="d-block">
                    <label for=""><strong>{{$t('note')}}</strong></label>
                    <b-form-textarea rows="3" v-model="formData.note" placeholder="Enter note"></b-form-textarea>
                </div>
                <b-button class="mt-4" @click="$bvModal.hide('bv-modal-example')"><font-awesome-icon icon="times"></font-awesome-icon> Cancel</b-button>
                <b-button variant="primary" type="submit" class="mt-4 float-right"><font-awesome-icon icon="spinner" spin v-if="isLoading"></font-awesome-icon> <font-awesome-icon icon="save" v-else></font-awesome-icon> Submit</b-button>
            </form>
        </b-modal>
    </b-card>
</template>

<script>
    import 'viewerjs/dist/viewer.css'
    import Viewer from 'v-viewer'
    import Vue from 'vue'
    Vue.use(Viewer)

    export default {
        name: 'report-show',
        data () {
            return {
                isLoading: false,
                apiUrl: {
                    overtime: window.AppConfig.apiUrl + 'overtime',
                    overtimePhoto: window.AppConfig.apiUrl + 'overtime-photo',
                    overtimeHistoryStatus: window.AppConfig.apiUrl + 'overtime-history-status'
                },
                type: null,
                formData: {
                    note: null
                },
                // mainProps: { blank: true, width: 75, height: 75, class: 'm1' },
                model: {
                    hour: 0,
                    requestedBy: '',
                    approvedBy: '',
                    startTime: '',
                    endTime: '',
                    status: '',
                    note: '',
                    createdAt: '',
                    changedBy: '',
                    position: {
                        lat: 0,
                        lng: 0
                    },
                    overtimeType: null,
                    statusText: '',
                    statusValue: '',
                    statusTime: '',
                    statusTextTime: '',
                    overtimePhotoList: []
                },
                overtimeHistoryStatusList: []
            }
        },
        mounted () {
            this.getDetail()
            this.getHistoryStatus()
        },
        methods: {
            showModal (type) {
                this.formData.note = null
                this.type = type
                this.$bvModal.show('bv-modal-example')
            },
            doTest (type) {
                console.log('do test')
                this.isLoading = true
                this.$http.post(window.AppConfig.apiUrl + 'overtime-action', {
                    uuid: this.$route.params.uuid,
                    action: type,
                    note: this.formData.note
                })
                .then(() => {
                    this.isLoading = false
                    // this.formData.note = null
                    // this.getDetail()
                    // this.getHistoryStatus()
                    // this.$bvModal.hide('bv-modal-example')
                    // this.$store.dispatch('notification/success', 'Overtime has been approve')
                })
                .catch(error => {
                    this.isLoading = false
                    this.$store.dispatch('notification/error', error)
                });
            },
            doChangeStatus (type) {
                this.isLoading = true
                this.$http.post(window.AppConfig.apiUrl + 'overtime-action', {
                    uuid: this.$route.params.uuid,
                    action: type,
                    note: this.formData.note
                })
                .then(() => {
                    this.isLoading = false
                    this.formData.note = null
                    this.getDetail()
                    this.getHistoryStatus()
                    this.$bvModal.hide('bv-modal-example')
                    this.$store.dispatch('notification/success', 'Overtime has been ' + type + ' ed')
                })
                .catch(error => {
                    this.isLoading = false
                    this.$store.dispatch('notification/error', error)
                });
            },
            getDetail () {
                this.isLoading = true
                this.$http.get(this.apiUrl.overtime + '/' + this.$route.params.uuid)
                .then(response => {
                    this.model.requestedBy = response.data.requestedBy !== null ? response.data.requestedBy : '-'
                    this.model.startTime = response.data.startTime !== null ? response.data.startTime : '-'
                    this.model.endTime = response.data.endTime !== null ? response.data.endTime : '-'
                    this.model.status = response.data.status !== null ? response.data.status : '-'
                    this.model.note = response.data.note !== null ? response.data.note : '-'
                    this.model.hour = response.data.hour !== null ? response.data.hour : 0
                    if (response.data.rejectedBy !== null) {
                        this.model.statusText = 'Rejected By'
                        this.model.statusTextTime = 'Rejected Time'
                        this.model.statusValue = response.data.rejectedBy
                        this.model.statusTime = response.data.rejectedTime !== null ? this.$moment(response.data.rejectedTime).format('YYYY-MM-DD hh:mm A') : '-'
                    }
                    if (response.data.approvedBy !== null) {
                        this.model.statusText = 'Approved By'
                        this.model.statusTextTime = 'Approved Time'
                        this.model.statusValue = response.data.approvedBy
                        this.model.statusTime = response.data.approvedTime !== null ? this.$moment(response.data.approvedTime).format('YYYY-MM-DD hh:mm A') : '-'
                    }
                    this.model.overtimeType = response.data.overtimeType !== null ? response.data.overtimeType.name : '-'
                    this.model.createdAt = response.data.createdAt !== null ? response.data.createdAt : '-'
                    this.model.position = {
                        lat: Number(response.data.latitude),
                        lng: Number(response.data.longitude)
                    }
                    this.model.overtimePhotoList = []
                    if (response.data.overtimePhoto !== null) {
                        response.data.overtimePhoto.forEach(data => {
                            this.model.overtimePhotoList.push(data.url)
                        })
                    }
                    // this.isLoading = false
                })
                .catch(error => {
                    this.isLoading = false
                    this.$store.dispatch('notification/error', error)
                })
            },
            getHistoryStatus () {
                this.isLoading = true
                this.$http.get(this.apiUrl.overtimeHistoryStatus + '?overtime_uuid=' + this.$route.params.uuid + '&ascending=1').then(response => {
                    this.overtimeHistoryStatusList = []
                    response.data._embedded.overtimeHistoryStatus.forEach(data => {
                        this.overtimeHistoryStatusList.push(data)
                    })
                    this.isLoading = false
                })
            },
            getDateTime (value) {
                if (value !== null) {
                    return this.$moment(value).format('YYYY-MM-DD HH:mm A')
                } else {
                    return '-'
                }
            },
            goBack () {
                window.goBack(this)
            },
            getStatusColor (val) {
                switch (val) {
                case 'Approved':
                    return 'success'
                    // eslint-disable-next-line no-unreachable
                    break
                case 'Requested':
                    return 'info'
                    // eslint-disable-next-line no-unreachable
                    break

                case 'Rejected':
                    return 'danger'
                    // eslint-disable-next-line no-unreachable
                    break
                }
            },
            hasRole (name) {
              let temp = false
              name.forEach((key) => {
                if (this.$store.getters['account/accountData'].role == key){
                  temp = true
                }
              })
              return temp
            }
        }
    }
</script>